import React from 'react'
import classnames from 'classnames'

const Columns = ({className, ...props }) => {
  const classes = classnames('columns', {}, className)
  return (
    <div className={classes} {...props} />
  )
}

export default Columns
